// File: api/portfolio.js

import api from './axios';

// API endpoints
const endpoints = {
  analyze: '/analyze',
  compare: '/compare',
  portfolio: '/api/v1/portfolio',
  optimalPortfolio: '/optimal-portfolio',
  users: '/api/v1/users',
  public: '/public/score'
};

// 0) Posts Public Portfolio

export const fetchPublic = async ({ email, portfolio }) => {
  try {
    const response = await api.post(endpoints.public, {
      email,
      portfolio,      
    });
    return response.score; // Return just the data
  } catch (error) {
    throw error; // Throw the error instead of returning it
  }
}


// 1) Analyze a portfolio
//    Expects { portfolio: {...}, risk_free_rate, lookback_years }
export const analyzePortfolio = async (portfolioData) => {
  try {
    // Typically we do: { portfolio: <object>, risk_free_rate: <num>, lookback_years: <num> }
    const response = await api.post(endpoints.analyze, {
      portfolio: portfolioData.portfolio,
      risk_free_rate: portfolioData.risk_free_rate ?? 0.05,
      lookback_years: portfolioData.lookback_years ?? 1
    });
    // `api` returns data as response.data (see axios interceptor).
    return response; 
  } catch (error) {
    throw new Error(error.message || 'Failed to analyze portfolio');
  }
};

// 2) Compare portfolio
//    Same shape as "analyze" for your /compare endpoint
export const comparePortfolio = async (portfolioData) => {
  try {
    const response = await api.post(endpoints.compare, {
      portfolio: portfolioData.portfolio,
      risk_free_rate: portfolioData.risk_free_rate ?? 0.05,
      lookback_years: portfolioData.lookback_years ?? 1
    });
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to compare portfolio');
  }
};

// 3) Get Optimal Portfolio (GET)
export const getOptimalPortfolio = async () => {
  try {
    const response = await api.get(endpoints.optimalPortfolio);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch optimal portfolio');
  }
};

// 4) GET the current user's portfolio
export const getUserPortfolio = async () => {
  try {
    const response = await api.get(endpoints.portfolio);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch portfolio');
  }
};

// 5) CREATE a new portfolio
//    Because your backend route is defined as:
//      create_portfolio(
//        portfolio: Dict[str, int],
//        ...
//      )
//    the request body must be exactly an object of {ticker: shares}.
export const createUserPortfolio = async (portfolioDict) => {
  // 'portfolioDict' must be a dictionary of tickers -> numbers, e.g.:
  //   { "AAPL": 100, "MSFT": 50 }
  // No name, no description, or you'll get a 422
  try {
    const response = await api.post(endpoints.portfolio, portfolioDict);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to create portfolio');
  }
};

// 6) UPDATE an existing portfolio
//    Because your backend route is defined as:
//      update_portfolio(
//        portfolio: Dict[str, float],
//        ...
//      )
//    the request body must again be just {ticker: shares} at the root.
export const updateUserPortfolio = async (portfolioDict) => {
  try {
    const response = await api.put(endpoints.portfolio, portfolioDict);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to update portfolio');
  }
};
